// Import React and ReactDOM
import React from 'react';
import ReactDOM from 'react-dom';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-React Plugin
import Framework7React from 'framework7-react';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '@otm/otm-core/styles/icons.css';
import '@otm/otm-core/styles/main.scss';
import '../css/app.scss';
import '../dbr';
// Import App Component
import App from '../components/app.js';

// Init F7 React Plugin
Framework7.use(Framework7React);

const DEPLOY_VERSION = '2026.03.27';
console.info(`[Customer Portal] Deploy version: ${DEPLOY_VERSION}`);

// Mount React App
ReactDOM.render(React.createElement(App), document.getElementById('app'));
